import { Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { SingleValueCard } from '../../../components/overview-card/single-value-card';
import { useMeasureComparisonData } from '../hooks/measure-comparison';
import { KPI_CONFIGS } from './overview.data';
import { aggregateMeasureValueAcrossEntities, formatKPIValue } from './overview.helpers';

/**
 * Renders the Process Analysis KPI overview row — a horizontal strip of
 * `SingleValueCard` tiles aggregating the most recent measure values across
 * the selected entities. Tiles render their value as a Skeleton on first
 * paint (no cached entity data yet) so the row keeps its footprint while
 * the underlying measure queries resolve.
 *
 * @returns {JSX.Element} The KPI overview row
 */
export const KPIOverview = () => {
  const { t } = useTranslation();
  const { entityData, isLoading } = useMeasureComparisonData();
  const showSkeleton = isLoading && Object.keys(entityData).length === 0;

  return (
    <Flex direction="row" gap={24}>
      {KPI_CONFIGS.map((config) => {
        const aggregatedValue = aggregateMeasureValueAcrossEntities(entityData, config.measure, config.aggregation);

        return (
          <SingleValueCard
            key={config.id}
            title={t(config.titleKey)}
            icon={config.icon}
            value={formatKPIValue(aggregatedValue)}
            unit={t(config.unitKey).toLowerCase()}
            isLoading={showSkeleton}
          />
        );
      })}
    </Flex>
  );
};
